module.exports = __webpack_public_path__ + "static/img/3798_phase_function_Paper_PointsHejduk_Prediction.5e3725b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3798_phase_function_Paper_PointsHejduk_Prediction.png
// module id = RDyX
// module chunks = 0